var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { createBooleanFlag, createFeatureRelayClient, createIntegerFlag, TokenType } from '@square/feature-relay-web-sdk';
export let FlagNames = /*#__PURE__*/function (FlagNames) {
  FlagNames["ADA_ENABLED_LOCALE"] = "ADA_ENABLED_LOCALE";
  FlagNames["AUTHORIZATION_AUTHZ_ENGINES_USER_HARD_CHECK_ENABLED"] = "AUTHORIZATION_AUTHZ_ENGINES_USER_HARD_CHECK_ENABLED";
  FlagNames["MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN"] = "MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN";
  FlagNames["USE_SPLIT_LOGIN"] = "USE_SPLIT_LOGIN";
  FlagNames["PRELOAD_DASHBOARD_ASSETS"] = "PRELOAD_DASHBOARD_ASSETS";
  FlagNames["ENABLE_ADD_PHONE_ALIAS"] = "ENABLE_ADD_PHONE_ALIAS";
  FlagNames["ENABLE_POST_LOGIN_ACCOUNT_COMPLETION"] = "ENABLE_POST_LOGIN_ACCOUNT_COMPLETION";
  FlagNames["EMPLOYEE_INVITATION_ERROR_LOGIN_BUTTON"] = "EMPLOYEE_INVITATION_ERROR_LOGIN_BUTTON";
  FlagNames["UI_ENABLE_SIGN_IN_PASSKEYS"] = "UI_ENABLE_SIGN_IN_PASSKEYS";
  FlagNames["PASSKEYS_ENABLED"] = "PASSKEYS_ENABLED";
  FlagNames["ENABLE_DATADOG_RUM"] = "ENABLE_DATADOG_RUM";
  FlagNames["CDP_HEARTBEAT_INTERVAL_SECONDS"] = "CDP_HEARTBEAT_INTERVAL_SECONDS";
  FlagNames["ENABLE_PASSKEY_PROMO"] = "ENABLE_PASSKEY_PROMO";
  FlagNames["PASSKEYS_USE_LEARN_MORE_PAGE"] = "PASSKEYS_USE_LEARN_MORE_PAGE";
  return FlagNames;
}({});
export const FLAG_CONFIGS = Object.freeze({
  ADA_ENABLED_LOCALE: createBooleanFlag({
    key: 'supportcenter-ada-enabled-in-locale',
    defaultValue: false
  }),
  AUTHORIZATION_AUTHZ_ENGINES_USER_HARD_CHECK_ENABLED: createBooleanFlag({
    key: 'authorization-authz-engines-user-hard-check-enabled',
    defaultValue: false
  }),
  MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN: createBooleanFlag({
    key: 'multipassui-use-app-subdomain-login',
    defaultValue: false
  }),
  USE_SPLIT_LOGIN: createBooleanFlag({
    key: 'multipass-use-split-login',
    defaultValue: false
  }),
  ENABLE_ADD_PHONE_ALIAS: createBooleanFlag({
    key: 'multipass-enable-add-phone-alias',
    defaultValue: false
  }),
  PRELOAD_DASHBOARD_ASSETS: createBooleanFlag({
    key: 'multipass-preload-dashboard-assets',
    defaultValue: false
  }),
  ENABLE_POST_LOGIN_ACCOUNT_COMPLETION: createBooleanFlag({
    key: 'multipass-enable-post-login-account-completion',
    defaultValue: false
  }),
  EMPLOYEE_INVITATION_ERROR_LOGIN_BUTTON: createBooleanFlag({
    key: 'employee-invitation-error-login-button',
    defaultValue: false
  }),
  UI_ENABLE_SIGN_IN_PASSKEYS: createBooleanFlag({
    key: 'multipass-ui-enable-sign-in-passkeys',
    defaultValue: false
  }),
  PASSKEYS_ENABLED: createBooleanFlag({
    key: 'multipass-passkeys-enabled',
    defaultValue: false
  }),
  ENABLE_DATADOG_RUM: createBooleanFlag({
    key: 'multipassui-enable-datadog-rum',
    defaultValue: false
  }),
  CDP_HEARTBEAT_INTERVAL_SECONDS: createIntegerFlag({
    key: 'multipass-cdp-heartbeat-interval-seconds',
    defaultValue: 5
  }),
  ENABLE_PASSKEY_PROMO: createBooleanFlag({
    key: 'multipassui-enable-passkey-promo',
    defaultValue: false
  }),
  PASSKEYS_USE_LEARN_MORE_PAGE: createBooleanFlag({
    key: 'multipassui-passkeys-use-learn-more-page',
    defaultValue: false
  })
});
let EmberMultipassFlagService = (_dec = service('ember-multipass-config'), _dec2 = service('ember-multipass-logging'), (_class = class EmberMultipassFlagService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "multipassConfig", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "cookies", _descriptor3, this);
    _defineProperty(this, "_flagValues", {});
  }
  /**
   * Create a http request to /1.0/features/get-flags.
   * Each request can send multiple flag names with one set of token and attributes.
   * If flags are based on different token/attributes, you need to initialize them separately
   * by calling initFlags multiple times.
   */
  async initFlags({
    names,
    token,
    userAttributes,
    tokenType
  }) {
    const userToken = {
      token,
      type: tokenType ?? TokenType.ANONYMOUS_VISITOR
    };
    const flagConfigs = {};
    names.forEach(name => {
      flagConfigs[name] = FLAG_CONFIGS[name];
    });
    const offlineMode = this.multipassConfig.environment === 'testing';
    const flagClient = createFeatureRelayClient({
      flagConfigs,
      userToken,
      userAttributes,
      offlineMode
    });
    try {
      await flagClient.loadFlags();
    } catch (e) {
      this.logger.error('Failed to load feature flags', e);
    }
    names.forEach(name => {
      const flagConfig = flagConfigs[name];
      this._flagValues[name] = flagConfig ? flagClient.getFlagValue(flagConfig) : FLAG_CONFIGS[name].defaultValue;
    });
  }
  getValue(name) {
    return this._flagValues[name] ?? FLAG_CONFIGS[name]?.defaultValue;
  }
  async loadAvtFlags() {
    const names = [FlagNames.MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN, FlagNames.USE_SPLIT_LOGIN, FlagNames.PRELOAD_DASHBOARD_ASSETS, FlagNames.ENABLE_ADD_PHONE_ALIAS, FlagNames.ENABLE_POST_LOGIN_ACCOUNT_COMPLETION, FlagNames.EMPLOYEE_INVITATION_ERROR_LOGIN_BUTTON, FlagNames.UI_ENABLE_SIGN_IN_PASSKEYS, FlagNames.CDP_HEARTBEAT_INTERVAL_SECONDS, FlagNames.ENABLE_PASSKEY_PROMO, FlagNames.PASSKEYS_USE_LEARN_MORE_PAGE];
    await this.initFlags({
      names,
      token: this.cookies.read('_savt')
    });
  }
  async loadPersonTokenFlags(personToken) {
    const names = [FlagNames.PASSKEYS_ENABLED];
    await this.initFlags({
      names,
      token: personToken,
      tokenType: TokenType.PERSON
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassConfig", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cookies", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { EmberMultipassFlagService as default };